<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('modification.voluntaryamendment.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('modification.voluntaryamendment.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.voluntaryamendment.fields.step_01') }}</h2>
              <p>{{ $t('modification.voluntaryamendment.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02 active">
              <h2>{{ $t('modification.voluntaryamendment.fields.step_02') }}</h2>
              <p>{{ $t('modification.voluntaryamendment.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('modification.voluntaryamendment.fields.step_03') }}</h2>
              <p>{{ $t('modification.voluntaryamendment.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <div>
              <ApplicationInformation2 :receipt_no="receipt_no" />
            </div>

            <div>
              <v-flex>
                <h3 class="m_title mt-30"><i>*</i> {{ $t('component.amended_biblio_details.reason_of_amendment')}}</h3>
              </v-flex>
              <v-flex class="item_box" style="border-bottom: none">
                <ValidationObserver ref="reason">
                  <div class="pa-0 ma-0">
                    <ValidationProvider v-slot="{ errors }" :name="$t('component.amended_biblio_details.reason_of_amendment')" :rules="{required: true}">
                      <v-textarea
                        outlined
                        class="login_text_filed"
                        counter
                        maxlength="1000"
                        v-model="amendment.notes"
                        :error-messages="errors"
                      ></v-textarea>
                    </ValidationProvider>
                  </div>
                </ValidationObserver>
              </v-flex>
              <v-flex>
                <h3 class="m_title mt-0">{{ $t('modification.voluntaryamendment.fields.request_amendment')}}</h3>
              </v-flex>
              <v-flex class="item_box">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.title')" v-model="amendment.ind_amd_title" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-show="amendment.ind_amd_title == 'Y'">
                <ValidationObserver ref="titleForm">

                  <div class="text__input__icontype not__ltr">
                    <div class="box__title">{{ $t('modification.voluntaryamendment.fields.ar') }}</div>
                    <div class="text__input__icontype__tf">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.title')" :rules="{required: amendment.ind_amd_title == 'Y'}">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="br_none ie_inpt login_text_field text-right redonly__renew"
                        :clearable="edit.amend_title_ar"
                        :readonly="!edit.amend_title_ar"
                        v-model="amendment.amend_title_ar"
                        :error-messages="errors"
                      ></v-text-field>
                      </ValidationProvider>
                    </div>
                    <div>
                      <v-btn icon class="modf_btn text-right" @click="fnChangeEditMode('amend_title_ar')">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="text__input__icontype not__ltr">
                    <div class="box__title">{{ $t('modification.voluntaryamendment.fields.en') }}</div>
                    <div class="text__input__icontype__tf">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.title')" :rules="{required: amendment.ind_amd_title == 'Y'}">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="br_none ie_inpt login_text_field text-left redonly__renew"
                        :clearable="edit.amend_title_en"
                        :readonly="!edit.amend_title_en"
                        v-model="amendment.amend_title_en"
                        :error-messages="errors"
                      ></v-text-field>
                      </ValidationProvider>
                    </div>
                    <div>
                      <v-btn icon class="modf_btn text-right" @click="fnChangeEditMode('amend_title_en')">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </ValidationObserver>
              </v-flex>

              <v-flex class="item_box" v-show="false">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.applicants')" v-model="amendment.ind_amd_applcant" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-if="amendment.ind_amd_applcant == 'Y'">
                <AmendmentApplicants
                  :receipt_no.sync="receipt_no"
                  :userInfo="userInfo"
                  :company="company"
                  :auto_insert="auto_insert_applicant"
                  :applicant_inventor.sync="applicant_inventor"
                  v-if="flag_applicant"
                  @success="fnRefreshComponent"
                />
              </v-flex>

              <v-flex class="item_box" v-show="false">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.inventors')" v-model="amendment.ind_amd_inventor" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-if="amendment.ind_amd_inventor == 'Y'">
                <AmendmentInventor
                  :receipt_no.sync="receipt_no"
                  :userInfo="userInfo"
                  :company="company"
                  v-if="flag_inventor"
                  @success="fnRefreshComponent"
                />
              </v-flex>

              <v-flex class="item_box" v-show="false">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.representative')" v-model="amendment.ind_amd_representative" value="Y">
                  </v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-if="amendment.ind_amd_representative == 'Y'">
                <h3 class="sub_title_box" style="background-color: #ffffff; border-top : 0px;" v-show="getApplicantBtnShow">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#333"
                    dark
                    height="25"
                    class="btn-normal ft-size11"
                    @click="getApplicantForRepresentative()"
                  >
                    {{ $t('application.patent.fields.get_the_applicants_information') }}
                  </v-btn>
                </h3>

                <AmendmentRepresentative
                  :receipt_no.sync="receipt_no"
                  :userInfo="userInfo"
                  :company="company"
                  :auto_insert="auto_insert_representative"
                  v-if="flag_representative"
                  @success="fnRefreshComponent"
                  ref="component_representative"
                  @empty="fnShowGetApplicant"
                />
              </v-flex>

              <v-flex class="item_box">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.priority_claim')" v-model="amendment.ind_amd_priority" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-show="amendment.ind_amd_priority == 'Y'">
                <v-data-table
                  :headers="$getHeaderType1(priorityHeaderTxt, priorityHeaders)"
                  :items="priorityList"
                  hide-default-footer
                  disable-pagination
                  class="new__type__table"
                >
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td style="cursor:pointer;" @click="fnPriorityClaimEdit(item.seq)">
                        {{ index + 1 }}
                      </td>
                      <td style="cursor:pointer;" @click="fnPriorityClaimEdit(item.seq)">
                        {{ item.priority_date }}
                      </td>
                      <td style="cursor:pointer;" @click="fnPriorityClaimEdit(item.seq)">
                        {{ item.priority_no }}
                      </td>
                      <td style="cursor:pointer;" @click="fnPriorityClaimEdit(item.seq)">
                        {{ item.priority_country_code }}
                      </td>
                      <td>
                        <p class="mt-20 mb--5">
                          <a v-if="fnIsNotNull(item.priority_ar_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_ar_file_key">
                            <v-icon>{{ getExtIcon(item.priority_ar_file_name) }}</v-icon>
                            <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                            {{item.priority_ar_file_name}}
                          </a>
                        </p>
                        <p>
                          <a v-if="fnIsNotNull(item.priority_en_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_en_file_key">
                            <v-icon>{{ getExtIcon(item.priority_en_file_name) }}</v-icon>
                            <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                            {{item.priority_en_file_name}}
                          </a>
                        </p>
                      </td>
                      <td>
                        <v-btn icon @click="fnPriorityDeleteConfirm(item.seq)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn
                      dense
                      outlined
                      dark
                      color="#a01c2a"
                      width="110px"
                      height="40px"
                      @click="fnPriorityClaimAdd()"
                    >
                      {{ $t('common.button.add') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- <div v-show="prioritySaveForm"> -->
                <div v-show="prioritySaveForm">
                  <v-divider style="border-color:#eee!important" class="mt-20"></v-divider>
                  <ValidationObserver ref="prioritySaveForm">
                    <v-form>
                      <v-row class="mt-15">
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.where_earlier_application_is') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <v-select
                              dense
                              outlined
                              class="ft-size12 br_none"
                              v-model="priority.priority_country_code"
                              :items="$vuetify.rtl ? countryArList : countryEnList"
                            >
                            </v-select>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.number_of_earlier_application') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <ValidationProvider v-slot="{ errors }" :name="'Number of earlier application'" :rules="{required: true}">
                              <v-text-field
                                dense
                                outlined
                                clearable
                                class="ft-size12  br_none"
                                v-model="priority.priority_no"
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.filling_date') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.filling_date')" :rules="{required: true}">
                                  <v-text-field
                                    solo
                                    flat
                                    dense
                                    outlined
                                    readonly
                                    v-on="on"
                                    v-bind="attrs"
                                    hint="DD/MM/YYYY format"
                                    append-icon="mdi-calendar"
                                    class="date_type  br_none"
                                    v-model="priority.priority_date"
                                    :error-messages="errors"
                                    @click:append="menu1 = true"
                                  ></v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker v-model="priorityCalDate" no-title @input="fnSetPriorityClaimDate()"></v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="mt--10">
                        <v-col cols="12" md="6" class="pt-0">
                          <label class="nec_title">{{$t('modification.voluntaryamendment.fields.priority_claim_arabic')}}</label>
                          <div class="input_text_type_basic file_type wp100 fileForm">
                            <v-file-input
                              dense
                              outlined
                              :placeholder="priority.priority_ar_file_name ? priority.priority_ar_file_name : $t('common.common.no_files_selected')"
                              :prepend-icon="$t('common.common.select_file')"
                              class="ft-size12 br_none wp100"
                              style="height:40px;"
                              v-model="priorityArFile"
                              @change="fnChangePriorityFileAr()"
                              clearable
                              @click:clear="fnInitPriorityFileAr()"
                              :append-icon="priority.priority_ar_file_name ? '$clear': ''"
                              @click:append="fnInitPriorityFileAr()"
                            >
                            </v-file-input>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <label class="nec_title">{{$t('modification.voluntaryamendment.fields.priority_claim_english')}}</label>
                          <div class="input_text_type_basic file_type wp100 fileForm">
                            <v-file-input
                              dense
                              outlined
                              :placeholder="priority.priority_en_file_name ? priority.priority_en_file_name : $t('common.common.no_files_selected')"
                              :prepend-icon="$t('common.common.select_file')"
                              class="ft-size12 br_none wp100"
                              style="height:40px;"
                              v-model="priorityEnFile"
                              @change="fnChangePriorityFileEn()"
                              clearable
                              @click:clear="fnInitPriorityFileEn()"
                              :append-icon="priority.priority_en_file_name ? '$clear': ''"
                              @click:append="fnInitPriorityFileEn()"
                            >
                            </v-file-input>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="mt--10">
                        <v-col cols="12" class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                            dense
                            height="50"
                            width="150"
                            dark
                            color="#a01c2a"
                            class="capitalize btn_basic br_none"
                            @click="fnSavePriorityClaim()"
                          >
                            {{ $t('common.button.save') }}
                          </v-btn>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          <v-btn
                            dense
                            height="50"
                            width="150"
                            class="capitalize btn_basic br_none btn-actv"
                            @click="fnCancelPriorityClaim()"
                          >
                            {{ $t('common.button.cancel') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </div>
              </v-flex>

              <v-flex class="item_box">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.temporaryprotection')" v-model="amendment.ind_amd_exhibition" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-show="amendment.ind_amd_exhibition == 'Y'">
                <v-data-table
                  :headers="$getHeaderType2(temporaryHeaderTxt, temporaryHeadersEn, temporaryHeadersAr)"
                  :items="temporaryList"
                  hide-default-footer
                  disable-pagination
                  class="new__type__table"
                >
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ index + 1 }}
                      </td>
                      <td style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ item.exhibition_country_code }}
                      </td>
                      <td v-if="$vuetify.rtl" style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ item.exhibition_name_ar }}
                      </td>
                      <td v-if="!$vuetify.rtl" style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ item.exhibition_name_en }}
                      </td>
                      <td style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ item.opening_date }}
                      </td>
                      <td style="cursor:pointer;" @click="fnTemporaryEdit(item.seq)">
                        {{ item.protection_date }}
                      </td>
                      <td>
                        <template v-if="fnIsNotNull(item.certificate_file_key)">
                          <v-icon>{{ getExtIcon(item.certificate_file_name) }}</v-icon>
                          <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                          <a style="text-decoration:none" :href="downLoadUrl + item.certificate_file_key">
                            {{item.certificate_file_name}}
                          </a>
                        </template>
                      </td>
                      <td>
                        <v-btn icon @click="fnTemporaryDeleteConfirm(item.seq)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn
                      dense
                      outlined
                      dark
                      color="#a01c2a"
                      width="110px"
                      height="40px"
                      @click="fnTemporaryAdd()"
                    >
                      {{ $t('common.button.add') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <div v-show="temporarySaveForm">
                  <v-divider style="border-color:#eee!important" class="mt-20"></v-divider>
                  <ValidationObserver ref="temporarySaveForm">
                    <v-form>
                      <v-row class="mt-15">
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.country') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <v-select
                              dense
                              outlined
                              class="ft-size12 br_none"
                              v-model="temporary.exhibition_country_code"
                              :items="$vuetify.rtl ? countryArList : countryEnList"
                            >
                            </v-select>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.exhibition_name_in_arabic') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.exhibition_name_in_arabic')" :rules="{required: true}">
                              <v-text-field
                                dense
                                outlined
                                clearable
                                class="ft-size12 br_none login_text_field arabic_align"
                                v-model="temporary.exhibition_name_ar"
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.exhibition_name_in_english') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.exhibition_name_in_english')" :rules="{required: true}">
                              <v-text-field
                                dense
                                outlined
                                clearable
                                class="ft-size12 br_none login_text_field text-left"
                                v-model="temporary.exhibition_name_en"
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="4" class="pt-0 pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.exhibition_opening_date') }}</label>
                          <div class="input_text_type_basic mt--5">
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.exhibition_opening_date')" :rules="{required: true}">
                                  <v-text-field
                                    solo
                                    flat
                                    dense
                                    outlined
                                    readonly
                                    v-on="on"
                                    v-bind="attrs"
                                    hint="DD/MM/YYYY format"
                                    append-icon="mdi-calendar"
                                    class="date_type  br_none"
                                    v-model="temporary.opening_date"
                                    :error-messages="errors"
                                    @click:append="menu2 = true"
                                  ></v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker v-model="temporaryCalDate1" no-title @input="fnSetTemporaryDate1()"></v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pt-0 pb-0">
                          <label class="nec_title">{{$t('modification.voluntaryamendment.fields.date_of_protection')}}</label>
                          <div class="input_text_type_basic mt--5">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.date_of_protection')" :rules="{required: true}">
                                  <v-text-field
                                    solo
                                    flat
                                    dense
                                    outlined
                                    readonly
                                    v-on="on"
                                    v-bind="attrs"
                                    hint="DD/MM/YYYY format"
                                    append-icon="mdi-calendar"
                                    class="date_type  br_none"
                                    v-model="temporary.protection_date"
                                    :error-messages="errors"
                                    @click:append="menu3 = true"
                                  ></v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker v-model="temporaryCalDate2" no-title @input="fnSetTemporaryDate2()"></v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pt-0 pb-0">
                          <label class="nec_title">{{ $t('modification.voluntaryamendment.fields.certificate_file') }}</label>
                          <div class="input_text_type_basic file_type mt--5 fileForm">
                            <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.certificate_file')" :rules="{required: true}">
                              <v-file-input
                                dense
                                outlined
                                :placeholder="temporary.certificate_file_name ? temporary.certificate_file_name : $t('common.common.no_files_selected')"
                                :prepend-icon="$t('common.common.select_file')"
                                class="ft-size12 br_none"
                                style="height:40px;"
                                v-model="temporaryFile"
                                @change="fnChangeTemporaryFile()"
                                :error-messages="errors"
                                clearable
                                @click:clear="fnInitTemporaryFile()"
                                :append-icon="temporary.certificate_file_name ? '$clear': ''"
                                @click:append="fnInitTemporaryFile()"
                              >
                              </v-file-input>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>


                      <v-row class="mt--10">
                        <v-col cols="12" class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                            dense
                            height="50"
                            width="150"
                            dark
                            color="#a01c2a"
                            class="capitalize btn_basic br_none"
                            @click="fnSaveTemporary()"
                          >
                            {{ $t('common.button.save') }}
                          </v-btn>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          <v-btn
                            dense
                            height="50"
                            width="150"
                            class="capitalize btn_basic br_none btn-actv"
                            @click="fnCancelTemporary()"
                          >
                            {{ $t('common.button.cancel') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </div>
              </v-flex>

              <v-flex class="item_box">
                <div>
                  <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.abstract')" v-model="amendment.ind_amd_abstract" value="Y"></v-checkbox>
                </div>
              </v-flex>
              <v-flex class="item_box" v-show="amendment.ind_amd_abstract == 'Y'">
                <ValidationObserver ref="abstractForm">
                  <div class="input_text_type_basic title_box_type">
                    <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.abstract')" :rules="{required: amendment.ind_amd_abstract == 'Y'}">
                      <div class="text__textarea__icontype not__ltr">
                        <v-btn class="text-right text_area_typea penc__btn__textarea" @click="fnChangeEditMode('amend_abstract_ar')">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <div class="text__textarea__icontype__tf">
                          <v-textarea
                            outlined
                            class="br_none ie_textarea login_text_field text-right"
                            width="100%"
                            :clearable="edit.amend_abstract_ar"
                            :readonly="!edit.amend_abstract_ar"
                            v-model="amendment.amend_abstract_ar"
                            :error-messages="errors"
                          >
                          </v-textarea>
                        </div>
                        <div class="box__title">{{$t('common.common.ar')}}</div>
                      </div>
                    </ValidationProvider>
                  </div>

                  <div class="input_text_type_basic title_box_type mt-20">
                    <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.abstract')" :rules="{required: amendment.ind_amd_abstract == 'Y'}">
                      <div class="text__textarea__icontype not__ltr">
                        <div class="box__title">{{$t('common.common.en')}}</div>
                        <div class="text__textarea__icontype__tf">
                          <v-textarea
                            outlined
                            class="br_none ie_textarea login_text_field text-left"
                            width="100%"
                            :clearable="edit.amend_abstract_en"
                            :readonly="!edit.amend_abstract_en"
                            v-model="amendment.amend_abstract_en"
                            :error-messages="errors"
                          >
                          </v-textarea>
                        </div>
                        <v-btn class="text-right text_area_typea penc__btn__textarea" @click="fnChangeEditMode('amend_abstract_en')">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </ValidationProvider>
                  </div>
                </ValidationObserver>
              </v-flex>

              <ValidationObserver ref="filesForm">
                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.claim_in_arabic')" v-model="amendment.ind_amd_claim_ar" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_claim_ar == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.claim_in_arabic')" :rules="{required: (amendment.ind_amd_claim_ar == 'Y' && !fnIsNotNull(documents.claimAr.document_file_key))}">
                        <v-file-input
                          dense
                          outlined
                          style="height : 40px;"
                          class="ft-size12 br_none"
                          :prepend-icon="$t('common.common.select_file')"
                          :placeholder="documents.claimAr.document_file_name ? documents.claimAr.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('claimAr', documents.claimAr.index)"
                          v-model="documents.claimAr.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('claimAr', documents.claimAr.index)"
                          :append-icon="documents.claimAr.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('claimAr', documents.claimAr.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.claim_in_english')" v-model="amendment.ind_amd_claim_en" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_claim_en == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.claim_in_english')" :rules="{required: (amendment.ind_amd_claim_en == 'Y' && !fnIsNotNull(documents.claimEn.document_file_key))}">
                        <v-file-input
                          dense
                          outlined
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          style="height : 40px;"
                          :placeholder="documents.claimEn.document_file_name ? documents.claimEn.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('claimEn', documents.claimEn.index)"
                          v-model="documents.claimEn.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('claimEn', documents.claimEn.index)"
                          :append-icon="documents.claimEn.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('claimEn', documents.claimEn.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.description_in_arabic')" v-model="amendment.ind_amd_description_ar" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_description_ar == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.description_in_arabic')" :rules="{required: (amendment.ind_amd_description_ar == 'Y' && !fnIsNotNull(documents.descAr.document_file_key))}">
                        <v-file-input
                          outlined
                          dense
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          style="height : 40px;"
                          :placeholder="documents.descAr.document_file_name ? documents.descAr.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('descAr', documents.descAr.index)"
                          v-model="documents.descAr.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('descAr', documents.descAr.index)"
                          :append-icon="documents.descAr.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('descAr', documents.descAr.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.description_in_english')" v-model="amendment.ind_amd_description_en" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_description_en == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.description_in_english')" :rules="{required: (amendment.ind_amd_description_en == 'Y' && !fnIsNotNull(documents.descEn.document_file_key))}">
                        <v-file-input
                          outlined
                          dense
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          style="height : 40px;"
                          :placeholder="documents.descEn.document_file_name ? documents.descEn.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('descEn', documents.descEn.index)"
                          v-model="documents.descEn.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('descEn', documents.descEn.index)"
                          :append-icon="documents.descEn.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('descEn', documents.descEn.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.drawing_in_arabic')" v-model="amendment.ind_amd_drawing_ar" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_drawing_ar == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.drawing_in_arabic')" :rules="{required: (amendment.ind_amd_drawing_ar == 'Y' && !fnIsNotNull(documents.drawAr.document_file_key))}">
                        <v-file-input
                          outlined
                          dense
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          style="height : 40px;"
                          :placeholder="documents.drawAr.document_file_name ? documents.drawAr.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('drawAr', documents.drawAr.index)"
                          v-model="documents.drawAr.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('drawAr', documents.drawAr.index)"
                          :append-icon="documents.drawAr.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('drawAr', documents.drawAr.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box">
                  <div>
                    <v-checkbox class="mt-0 pt-0" hide-details :label="$t('modification.voluntaryamendment.fields.drawing_in_english')" v-model="amendment.ind_amd_drawing_en" value="Y"></v-checkbox>
                  </div>
                </v-flex>
                <v-flex class="item_box" v-show="amendment.ind_amd_drawing_en == 'Y'">
                  <v-col cols="6" class="pa-0">
                    <div class="input_text_type_basic file_type fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('modification.voluntaryamendment.fields.drawing_in_english')" :rules="{required: (amendment.ind_amd_drawing_en == 'Y' && !fnIsNotNull(documents.drawEn.document_file_key))}">
                        <v-file-input
                          outlined
                          dense
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none"
                          style="height : 40px;"
                          :placeholder="documents.drawEn.document_file_name ? documents.drawEn.document_file_name : $t('common.common.no_files_selected')"
                          @change="fnChangeDocsFile('drawEn', documents.drawEn.index)"
                          v-model="documents.drawEn.file"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitDocsFile('drawEn', documents.drawEn.index)"
                          :append-icon="documents.drawEn.document_file_name ? '$clear': ''"
                          @click:append="fnInitDocsFile('drawEn', documents.drawEn.index)"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box pa-0" v-show="othersFormShow">
                  <h2 class="m_title solo mt-35">{{ $t('modification.voluntaryamendment.fields.attachment') }}</h2>
                  <template v-for="(item, index) in attachDocList">
                    <v-row v-if="item.ind_filing == 'N'" class="ma-0 mt-15" :key="index">
                      <v-col class="pl-15 pr-15">
                        <h2 class="nec_title">&nbsp;<i v-if="item.ind_required === 'Y'">* </i>{{ $vuetify.rtl ? item.name_ar : item.name_en }}</h2>
                        <div class="d-flex ft-size12 color_red" v-if="item.ind_required === 'Y' && item.spec_type_code === '4209'">
                          {{ $t('common.message.submit_poa') }}
                        </div>
                        <div class="d-flex ft-size12 color_red" v-if="item.spec_type_code === '4262'">
                          {{ $t('modification.voluntaryamendment.fields.comments_file_msg') }}
                        </div>
                        <div class="d-flex mt-15 mb-15">
                          <div class="input_text_type_basic file_type wp50">
                            <template v-for="(document_file, file_index) in item.document_files">
                              <div class="fileForm" :key="file_index" :class="{'mt-10' : file_index != 0}">
                                <ValidationProvider v-slot="{ errors }" :name="$vuetify.rtl ? item.name_ar : item.name_en" :rules="{required: item.ind_required == 'Y' && !document_file.document_file_key}">
                                  <v-file-input
                                    :accept="fnGetAcceptExts(item.doc_exts)"
                                    solo
                                    outlined
                                    flat
                                    dense
                                    :placeholder="document_file.document_file_name ? document_file.document_file_name : $t('common.common.no_files_selected')"
                                    :prepend-icon="$t('common.common.select_file')"
                                    class="ft-size12"
                                    v-model="document_file.file"
                                    :error-messages="errors"
                                    :append-icon="document_file.document_file_name ? '$clear':''"
                                    @click:append="fnInitFileForm(document_file)"
                                    clearable
                                    @click:clear="fnInitFileForm(document_file)"
                                    @change="fnUploadFile(item, document_file)"
                                    style="height: 40px;"
                                  ></v-file-input>
                                </ValidationProvider>
                              </div>
                              <div :key="file_index + '_btn'" >
                                <v-spacer class="hidden_lr5"></v-spacer>
                                <div v-if="item.ind_multi_upload == 'Y'">
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd"
                                    @click="fnAddFileForm(item)"
                                    v-show="file_index == 0"
                                  >
                                    {{ $t('appealoppsition.opposition.fields.add_document') }}
                                  </v-btn>
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd del__btn"
                                    @click="fnDelFileForm(document_file, file_index)"
                                    v-show="file_index > 0"
                                  >
                                    {{$t('common.button.delete')}}
                                  </v-btn>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </v-flex>
              </ValidationObserver>
            </div>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                style="color: #FFF"
                @click="fnGoNextStep()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>

    <confirm-dialog
      :id="id"
      @deletePriorityClaim="fnDeletePriorityClaim"
      @deleteTemporary="fnDeleteTemporary"
    />

    <v-dialog
      v-model="dialog_get_applicants_representative"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >
      <v-card class="br_none modal_comfirm_wrap type4">
        <v-btn class="modal_close" @click="dialog_get_applicants_representative = false" fab color="white">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02 type4">{{ $t('application.temporaryprotection.fields.get_applicants') }}</h2>
      </v-card>

      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <perfect-scrollbar ref="pfscroll" class="h420" style="width: 100%; padding-left: 30px; padding-right: 30px;">
            <v-data-table
              :headers="$getHeaderType1(headerTxt2, headers2)"
              :items="applicants_representative"
              hide-default-footer
              :items-per-page="5"
              class="elevation-0"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <p>{{ item.name_ar }}</p>
                    <p>{{ item.name_en }}</p>
                  </td>
                  <td>
                    <p>{{ item.address_ar }}</p>
                    <p>{{ item.address_en }}</p>
                  </td>
                  <td>
                      {{ item.applicant_type_code }}
                  </td>
                  <td>
                    {{ item.residence_country_code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        color="#a01c2a"
                        dark
                        class="btn-normal br_none ft-size11"
                        @click="fnShowRepresentativeForm(item.seq)"
                      >
                        {{ $t('common.button.add')}}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </perfect-scrollbar>
        </v-flex>
      </v-layout>
    </v-dialog>

    <RepresentativeAdd
      :receipt_no.sync="receipt_no"
      :addParams.sync="addParams"
      v-if="dialog_representative_form"
      @success="fnSuccessAddRepresentative"
    />
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'

import AmendmentApplicants from '@/components/layout/AmendmentApplicants'
import AmendmentInventor from '@/components/layout/AmendmentInventor'
import AmendmentRepresentative from '@/components/layout/AmendmentRepresentative'
import RepresentativeAdd from '@/components/layout/AmendmentRepresentativeAdd'

export default {
  name: 'VoluntaryamendmentStep2',
  components :{
    ValidationObserver,
    ValidationProvider,
    ConfirmDialog,
    ApplicationInformation2,
    AmendmentApplicants,
    AmendmentInventor,
    AmendmentRepresentative,
    RepresentativeAdd
  },
  data() {
    return {

      //application 검색결과
      search : {
        application_no : '',
        title_ar : '',
        title_en : '',
        applicant_name_list_ar : '',
        applicant_name_list_en : ''
      },

      id: 'VoluntaryamendmentStep2',
      //
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      menu1 : false,
      menu2 : false,
      menu3 : false,

      receipt_no : this.$route.params.receipt_no,

      //amendment

      amendment : {
        ind_amd_title : 'N',
        ind_amd_applcant : 'N',
        ind_amd_inventor : 'N',
        ind_amd_representative : 'N',
        ind_amd_correspondence : 'N',
        ind_amd_priority : 'N',
        ind_amd_exhibition : 'N',
        ind_amd_abstract : 'N',
        ind_amd_claim_ar : 'N',
        ind_amd_claim_en : 'N',
        ind_amd_description_ar : 'N',
        ind_amd_description_en : 'N',
        ind_amd_drawing_ar : 'N',
        ind_amd_drawing_en : 'N',
        ind_amd_etc : 'N',
        amend_title_ar : '',
        amend_title_en : '',
        amend_abstract_ar : '',
        amend_abstract_en : '',
        notes: '',
        documents : []
      },

      edit : {
        amend_title_ar : false,
        amend_title_en : false,
        amend_abstract_ar : false,
        amend_abstract_en : false
      },

      priorityHeaderTxt : {
        prefix : 'modification.voluntaryamendment.fields.',
        txt : [ '#', 'filing_date_of_earlier_application','number_of_earlier_application','country','priority_documents','' ]
      },

      priorityHeaders: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('modification.voluntaryamendment.fields.filing_date_of_earlier_application'), align: 'center', value: 'priority_date' },
        { text: this.$t('modification.voluntaryamendment.fields.number_of_earlier_application'), align: 'center', value: 'priority_no' },
        { text: this.$t('modification.voluntaryamendment.fields.country'), align: 'center', value: 'priority_country_code' },
        { text: this.$t('modification.voluntaryamendment.fields.priority_documents'), sortable: false, align: 'center', value: '' },
        { text: '', sortable: false, align: 'center', value: '' },
      ],
      priorityList : [],
      // 신규 추가 및 변경 폼
      prioritySaveMode : '',
      prioritySaveForm : false,
      priority : {
        seq : null,
        amend_seq : null,
        priority_country_code : '',
        priority_no : '',
        priority_date : '',
        priority_en_file_key : '',
        priority_ar_file_key : ''
      },
      priorityArFile : null,
      priorityEnFile : null,
      priorityCalDate  : null,

      //
      temporaryHeaderTxt : {
        prefix : 'modification.voluntaryamendment.fields.',
        txt : [ '#', 'country','exhibition_name','exhibition_opening_date','date_of_protection','attachment','' ]
      },
      temporaryHeadersAr: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('modification.voluntaryamendment.fields.country'), align: 'center', value: 'exhibition_country_code' },
        { text: this.$t('modification.voluntaryamendment.fields.exhibition_name'), align: 'center', value: 'exhibition_name_ar' },
        { text: this.$t('modification.voluntaryamendment.fields.exhibition_opening_date'), align: 'center', value: 'opening_date' },
        { text: this.$t('modification.voluntaryamendment.fields.date_of_protection'), align: 'center', value: 'protection_date' },
        { text: this.$t('modification.voluntaryamendment.fields.attachment'), sortable: false, align: 'center', value: '' },
        { text: '', sortable: false, align: 'center', value: '' },
      ],
      temporaryHeadersEn: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('modification.voluntaryamendment.fields.country'), align: 'center', value: 'exhibition_country_code' },
        { text: this.$t('modification.voluntaryamendment.fields.exhibition_name'), align: 'center', value: 'exhibition_name_en' },
        { text: this.$t('modification.voluntaryamendment.fields.exhibition_opening_date'), align: 'center', value: 'opening_date' },
        { text: this.$t('modification.voluntaryamendment.fields.date_of_protection'), align: 'center', value: 'protection_date' },
        { text: this.$t('modification.voluntaryamendment.fields.attachment'), sortable: false, align: 'center', value: '' },
        { text: '', sortable: false, align: 'center', value: '' },
      ],
      temporaryList : [],

      temporarySaveMode : '',
      temporarySaveForm : false,

      temporary : {
        seq : null,
        amend_seq : null,
        exhibition_name_ar : '',
        exhibition_name_en : '',
        exhibition_country_code : '',
        opening_date : '',
        protection_date : '',
        certificate_file_key : '',
        certificate_file_name : ''
      },
      temporaryFile : null,
      temporaryCalDate1  : null,
      temporaryCalDate2  : null,

      // 나라 코드
      countryArList : [],
      countryEnList : [],

      documents : {
        claimAr : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null
        },
        claimEn : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null

        },
        descAr : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null

        },
        descEn : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null
        },
        drawAr : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null
        },
        drawEn : {
          index : null,
          document_file_key : '',
          document_file_name : '',
          file : null
        }
      },

      //컴포넌트에 넘길 정보들
      userInfo : {
        seq : '',
        company_seq : '',
        email : '',
        lasted_login_date : '',
        login_failed_count : '',
        account_lock_date : '',
        user_status_type_code : '',
        name_ar : '',
        name_en : '',
        personal_identify_no : '',
        valid_until_date : '',
        strong_auth_type_code : '',
        user_group_type_code : '',
        user_type_code : '',
        agent_no : '',
        birthday_date : '',
        gender_type_code : '',
        id_card_file_key : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        pobox : '',
        postal : '',
        nationality_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        avatar_file_key : '',
        sign_image : '',
        ind_representative : '',
        agent_authorization_type_code : '',
        ind_active : ''
      },

      company : {
        seq : '',
        company_type_code : '',
        company_regiration_no : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        residence_country_name_ar : '',
        residence_country_name_en : '',
        pobox : '',
        postal : '',
        registry_cert_file_key : '',
        registry_cert_file_name : '',
        registry_cert_file_ext : '',
        company_status_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        representative_email : ''
      },

      // 컴포넌트용
      applicant_inventor : false,
      correspondence_representative : false,
      auto_insert_applicant : false,
      auto_insert_representative : false,
      flag_applicant : true,
      flag_inventor : true,
      flag_representative : true,
      flag_correspondence : true,

      getApplicantBtnShow : false,

      dialog_get_applicants_representative : false,

      headerTxt2 : {
        prefix : 'modification.voluntaryamendment.fields.',
        txt : [ '#', 'name','address','applicant_type','residence','' ]
      },

      headers2: [
        { text: '#', align: 'center', width: '50px', sortable: false},
        { text: 'Name', align: 'center', width:'180px', sortable: false },
        { text: 'Address', align: 'center', sortable: false },
        { text: 'Applicant Type', align: 'center', width: '125px', sortable: false },
        { text: 'Residence',  align: 'center', width: '98px', sortable: false },
        { text: '',  align: 'center', width: '100px', sortable: false }
      ],

      applicants_representative : [],

      addParams : {
        nationality_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date : '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : '',
        agent_no : '',
        rep_scope_type_code : '',
        poa_upload_type_code : '',
        poa_reference_app_no : '',
        poa_file_key : '',
        applicants : [],
      },
      dialog_representative_form : false,

      requestFormShow: false,
      othersFormShow: false,
      attachDocList: [],

    }
  },
  mounted(){
    window.scrollTo(0, 0)
    // 커포넌트에 넘길 정보들
    this.fnGetReceipt()
    this.fnGetUserInfo()
    this.fnGetCountryList()
    this.fnGetAmendmentInfo()
    this.fnGetPriorityClaimList()
    this.fnGetPriorityClaimList()
    this.fnGetTemporaryList()
    this.fnGetAttachDocList()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.amendment.notes = res.data.notes

            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6407'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetApplicationInfo(){
      requestApi({
        url: '/applications/search/'+this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.search.application_no = res.data.application_no
            this.search.title_ar = res.data.title_ar
            this.search.title_en = res.data.title_en
            this.search.applicant_name_list_ar = res.data.applicant_name_list_ar
            this.search.applicant_name_list_en = res.data.applicant_name_list_en
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicationInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetUserInfo(){
      //사용자정보 조회
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.userInfo.seq = res.data.seq
            this.userInfo.company_seq = res.data.company_seq
            this.userInfo.email = res.data.email
            this.userInfo.lasted_login_date = res.data.lasted_login_date
            this.userInfo.login_failed_count = res.data.login_failed_count
            this.userInfo.account_lock_date = res.data.account_lock_date
            this.userInfo.user_status_type_code = res.data.user_status_type_code
            this.userInfo.name_ar = res.data.name_ar
            this.userInfo.name_en = res.data.name_en
            this.userInfo.personal_identify_no = res.data.personal_identify_no
            this.userInfo.valid_until_date = res.data.valid_until_date
            this.userInfo.strong_auth_type_code = res.data.strong_auth_type_code
            this.userInfo.user_group_type_code = res.data.user_group_type_code
            this.userInfo.user_type_code = res.data.user_type_code
            this.userInfo.agent_no = res.data.agent_no
            this.userInfo.birthday_date = res.data.birthday_date
            this.userInfo.gender_type_code = res.data.gender_type_code
            this.userInfo.id_card_file_key = res.data.id_card_file_key
            this.userInfo.address_ar = res.data.address_ar
            this.userInfo.address_en = res.data.address_en
            this.userInfo.city_name_ar = res.data.city_name_ar
            this.userInfo.city_name_en = res.data.city_name_en
            this.userInfo.residence_country_code = res.data.residence_country_code
            this.userInfo.pobox = res.data.pobox
            this.userInfo.postal = res.data.postal
            this.userInfo.nationality_code = res.data.nationality_code
            this.userInfo.telephone = res.data.telephone
            this.userInfo.mobile = res.data.mobile
            this.userInfo.fax = res.data.fax
            this.userInfo.avatar_file_key = res.data.avatar_file_key
            this.userInfo.sign_image = res.data.sign_image
            this.userInfo.ind_representative = res.data.ind_representative
            this.userInfo.agent_authorization_type_code = res.data.agent_authorization_type_code
            this.userInfo.ind_active = res.data.ind_active

            if(res.data.user_type_code != '2704' && res.data.user_type_code != '2705' ){
              //개인 사용자가 아니라면(company거나 agent) 회사 정보도 가져온다
              requestApi({
                url: '/users/company/information',
                method: 'GET',
                callback: (res) => {
                  if (res.res_code === '200') {
                    this.company.seq = res.data.seq
                    this.company.company_type_code = res.data.company_type_code
                    this.company.company_regiration_no = res.data.company_regiration_no
                    this.company.name_ar = res.data.name_ar
                    this.company.name_en = res.data.name_en
                    this.company.address_ar = res.data.address_ar
                    this.company.address_en = res.data.address_en
                    this.company.city_name_ar = res.data.city_name_ar
                    this.company.city_name_en = res.data.city_name_en
                    this.company.residence_country_code = res.data.residence_country_code
                    this.company.residence_country_name_ar = res.data.residence_country_name_ar
                    this.company.residence_country_name_en = res.data.residence_country_name_en
                    this.company.pobox = res.data.pobox
                    this.company.postal = res.data.postal
                    this.company.registry_cert_file_key = res.data.registry_cert_file_key
                    this.company.registry_cert_file_name = res.data.registry_cert_file_name
                    this.company.registry_cert_file_ext = res.data.registry_cert_file_ext
                    this.company.company_status_type_code = res.data.company_status_type_code
                    this.company.telephone = res.data.telephone
                    this.company.mobile = res.data.mobile
                    this.company.fax = res.data.fax
                    this.company.representative_email = res.data.representative_email
                  }else{
                    if (res.res_code === '401012') {
                      utils.setTokenRefresh().then(() => {
                        this.fnGetUserInfo()
                      })
                    } else {
                      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                    }
                  }
                }
              })
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetUserInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnRefreshComponent(){

    },
    fnGetCountryList(){
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })
    },
    fnGetAmendmentInfo(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.amendment.ind_amd_abstract       = res.data.ind_amd_abstract
            this.amendment.ind_amd_applcant       = 'N'
            this.amendment.ind_amd_claim_ar       = res.data.ind_amd_claim_ar
            this.amendment.ind_amd_claim_en       = res.data.ind_amd_claim_en
            this.amendment.ind_amd_correspondence = 'N'
            this.amendment.ind_amd_description_ar = res.data.ind_amd_description_ar
            this.amendment.ind_amd_description_en = res.data.ind_amd_description_en
            this.amendment.ind_amd_drawing_ar     = res.data.ind_amd_drawing_ar
            this.amendment.ind_amd_drawing_en     = res.data.ind_amd_drawing_en
            this.amendment.ind_amd_etc            = res.data.ind_amd_etc
            this.amendment.ind_amd_exhibition     = res.data.ind_amd_exhibition
            this.amendment.ind_amd_inventor       = 'N'
            this.amendment.ind_amd_priority       = res.data.ind_amd_priority
            this.amendment.ind_amd_representative = 'N'
            this.amendment.ind_amd_title          = res.data.ind_amd_title
            this.amendment.ind_amended_confirm    = res.data.ind_amended_confirm

            this.amendment.amend_title_ar = res.data.amend_title_ar
            this.amendment.amend_title_en = res.data.amend_title_en
            this.amendment.amend_abstract_ar = res.data.amend_abstract_ar
            this.amendment.amend_abstract_en = res.data.amend_abstract_en

            this.amendment.documents = res.data.documents

            for (let i = 0; i < res.data.documents.length; i++) {

              switch (res.data.documents[i].spec_type_code) {
                case '4202':
                  if(res.data.documents[i].lang_type_code == '4102'){
                    this.documents.claimAr.index = i
                    this.documents.claimAr.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.claimAr.document_file_name = res.data.documents[i].document_file_name
                  }else{
                    this.documents.claimEn.index = i
                    this.documents.claimEn.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.claimEn.document_file_name = res.data.documents[i].document_file_name
                  }
                break;
                case '4203':
                  if(res.data.documents[i].lang_type_code == '4102'){
                    this.documents.descAr.index = i
                    this.documents.descAr.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.descAr.document_file_name = res.data.documents[i].document_file_name
                  }else{
                    this.documents.descEn.index = i
                    this.documents.descEn.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.descEn.document_file_name = res.data.documents[i].document_file_name
                  }
                break;
                case '4204':
                  if(res.data.documents[i].lang_type_code == '4102'){
                    this.documents.drawAr.index = i
                    this.documents.drawAr.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.drawAr.document_file_name = res.data.documents[i].document_file_name
                  }else{
                    this.documents.drawEn.index = i
                    this.documents.drawEn.document_file_key  = res.data.documents[i].document_file_key
                    this.documents.drawEn.document_file_name = res.data.documents[i].document_file_name
                  }
                break;
              }
            }

          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAmendmentInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPriorityClaimList(){
      requestApi({
        url:  '/receivings/amendment/' + this.receipt_no + '/priorities',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no =  res.data.list.length - i
            }
            this.priorityList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPriorityClaimList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnPriorityFormInit(){
      this.priority.seq = null
      this.priority.amend_seq = null
      this.priority.priority_country_code = 'EG'
      this.priority.priority_no = ''
      this.priority.priority_date = ''
      this.priority.priority_en_file_key = ''
      this.priority.priority_ar_file_key = ''

      this.priorityCalDate = ''
      this.priorityArFile = null
      this.priorityEnFile = null
    },
    fnPriorityClaimAdd(){
      this.prioritySaveMode = 'add'
      this.prioritySaveForm = true
      this.fnPriorityFormInit()
      requestAnimationFrame(() => {
        this.$refs.prioritySaveForm.reset()
      })
    },
    fnCancelPriorityClaim(){
      this.prioritySaveForm = false
      this.fnPriorityFormInit()
      requestAnimationFrame(() => {
        this.$refs.prioritySaveForm.reset()
      })
    },
    fnPriorityClaimEdit(seq){
      this.fnPriorityFormInit()
      this.prioritySaveMode = 'edit'

      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/priorities/' + seq,
        method: 'GET',
        callback: (res) => {

          if (res.res_code === '200') {
            this.priority.seq                   = res.data.seq
            this.priority.amend_seq             = res.data.amend_seq
            this.priority.priority_country_code = res.data.priority_country_code
            this.priority.priority_no           = res.data.priority_no
            this.priority.priority_date         = res.data.priority_date
            this.priority.priority_en_file_key  = res.data.priority_en_file_key
            this.priority.priority_ar_file_key  = res.data.priority_ar_file_key
            this.priority.priority_en_file_name = res.data.priority_en_file_name
            this.priority.priority_ar_file_name = res.data.priority_ar_file_name

            this.priorityCalDate = this.formatDate2(res.data.priority_date)

            requestAnimationFrame(() => {
              this.$refs.prioritySaveForm.reset()
            })
            this.prioritySaveForm = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnPriorityClaimEdit(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

    },
    fnSetPriorityClaimDate(){
      this.priority.priority_date = this.formatDate(this.priorityCalDate)
      this.menu1 = false
    },
    fnPriorityDeleteConfirm(seq){
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'deletePriorityClaim',
          callback: {
            seq: seq
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)

    },
    fnDeletePriorityClaim(obj){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/priorities/' + obj.seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            let snackBarOptions = {
              text: this.$t('common.message.delete.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.fnGetPriorityClaimList()

            if(this.priority.seq == obj.seq){
              this.fnCancelPriorityClaim()
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeletePriorityClaim(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSavePriorityClaim(){
      this.$refs.prioritySaveForm.validate().then((valid) => {
        if(valid){
          if(this.prioritySaveMode == 'add'){
            this.fnAddPriorityClaim()
          }else if(this.prioritySaveMode == 'edit'){
            this.fnEditPriorityClaim()
          }
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnAddPriorityClaim(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/priorities',
        method: 'POST',
        data : this.priority,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
                text: this.$t('common.message.add.success')
              }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            requestAnimationFrame(() => {
              this.$refs.prioritySaveForm.reset()
            })
            this.prioritySaveForm = false
            this.fnPriorityFormInit()
            this.fnGetPriorityClaimList()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddPriorityClaim()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnEditPriorityClaim(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/priorities/' + this.priority.seq,
        method: 'PUT',
        data : this.priority,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
                text: this.$t('common.message.modify.success')
              }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            requestAnimationFrame(() => {
              this.$refs.prioritySaveForm.reset()
            })
            this.prioritySaveForm = false
            this.fnPriorityFormInit()
            this.fnGetPriorityClaimList()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnEditPriorityClaim()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnInitPriorityFileAr() {
      this.priorityArFile = null
      this.priority.priority_ar_file_key = ''
      this.priority.priority_ar_file_name = ''
    },
    fnChangePriorityFileAr(){
      if(!utils.isNull(this.priorityArFile)){
        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.priorityArFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.priority.priority_ar_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityFileAr()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.priorityArFile = null
                this.priority.priority_ar_file_key = ''
                this.priority.priority_ar_file_name = ''
              }
            }
          }
        })
      }
    },
    fnInitPriorityFileEn() {
      this.priorityEnFile = null
      this.priority.priority_en_file_key = ''
      this.priority.priority_en_file_name = ''
    },
    fnChangePriorityFileEn(){
      if(!utils.isNull(this.priorityEnFile)){
        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.priorityEnFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.priority.priority_en_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityFileEn()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.priorityEnFile = null
                this.priority.priority_en_file_key = ''
                this.priority.priority_en_file_name = ''
              }
            }
          }
        })
      }
    },

    //
    fnGetTemporaryList(){
      requestApi({
        url:  '/receivings/amendment/' + this.receipt_no + '/temporaries',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no =  res.data.list.length - i
            }
            this.temporaryList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetTemporaryList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnTemporaryFormInit(){
      this.temporary.seq = null
      this.temporary.amend_seq = null
      this.temporary.exhibition_country_code = 'EG'
      this.temporary.exhibition_name_ar = ''
      this.temporary.exhibition_name_en = ''
      this.temporary.opening_date = ''
      this.temporary.protection_date = ''
      this.temporary.certificate_file_key = ''
      this.temporary.certificate_file_name = ''

      this.temporaryCalDate1 = ''
      this.temporaryCalDate2 = ''
      this.temporaryFile = null
    },
    fnTemporaryAdd(){
      this.temporarySaveMode = 'add'
      this.temporarySaveForm = true
      this.fnTemporaryFormInit()
      requestAnimationFrame(() => {
        this.$refs.temporarySaveForm.reset()
      })
    },
    fnTemporaryEdit(seq){
      this.fnTemporaryFormInit()
      this.temporarySaveMode = 'edit'

      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/temporaries/' + seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.temporary.seq                     = res.data.seq
            this.temporary.amend_seq               = res.data.amend_seq
            this.temporary.exhibition_country_code = this.countryArList[0].value
            this.temporary.exhibition_name_ar      = res.data.exhibition_name_ar
            this.temporary.exhibition_name_en      = res.data.exhibition_name_en
            this.temporary.opening_date            = utils.replaceAll(res.data.opening_date, '/', '-')
            this.temporary.protection_date         = utils.replaceAll(res.data.protection_date, '/', '-')
            this.temporary.certificate_file_key    = res.data.certificate_file_key
            this.temporary.certificate_file_name   = res.data.certificate_file_name

            this.temporaryCalDate1                 = this.formatDate3(res.data.opening_date)
            this.temporaryCalDate2                 = this.formatDate3(res.data.protection_date)

            requestAnimationFrame(() => {
              this.$refs.temporarySaveForm.reset()
            })
            this.temporarySaveForm = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnTemporaryEdit(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSetTemporaryDate1(){
      this.temporary.opening_date = this.formatDate(this.temporaryCalDate1)
      this.menu2 = false
    },
    fnSetTemporaryDate2(){
      this.temporary.protection_date = this.formatDate(this.temporaryCalDate2)
      this.menu3 = false
    },
    fnTemporaryDeleteConfirm(seq){
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'deleteTemporary',
          callback: {
            seq: seq
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)

    },
    fnDeleteTemporary(obj){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/temporaries/' + obj.seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            let snackBarOptions = {
              text: this.$t('common.message.delete.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.fnGetTemporaryList()

            if(this.temporary.seq == obj.seq){
              this.fnCancelTemporary()
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteTemporary(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSaveTemporary(){
      this.$refs.temporarySaveForm.validate().then((valid) => {
        if(valid){
          if(this.temporarySaveMode == 'add'){
            this.fnAddTemporary()
          }else if(this.temporarySaveMode == 'edit'){
            this.fnEditTemporary()
          }
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnAddTemporary(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/temporaries',
        method: 'POST',
        data : this.temporary,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
                text: this.$t('common.message.add.success')
              }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            requestAnimationFrame(() => {
              this.$refs.temporarySaveForm.reset()
            })
            this.temporarySaveForm = false
            this.fnTemporaryFormInit()
            this.fnGetTemporaryList()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddTemporary()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnEditTemporary(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/temporaries/' + this.temporary.seq,
        method: 'PUT',
        data : this.temporary,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
                text: this.$t('common.message.modify.success')
              }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            requestAnimationFrame(() => {
              this.$refs.temporarySaveForm.reset()
            })
            this.temporarySaveForm = false
            this.fnTemporaryFormInit()
            this.fnGetTemporaryList()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnEditTemporary()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnCancelTemporary(){
      requestAnimationFrame(() => {
        this.$refs.temporarySaveForm.reset()
      })
      this.temporarySaveForm = false
      this.fnTemporaryFormInit()
    },
    fnInitTemporaryFile() {
      this.temporaryFile = null
      this.temporary.certificate_file_key = ''
      this.temporary.certificate_file_name = ''
    },
    fnChangeTemporaryFile(){
      if(!utils.isNull(this.temporaryFile)){
        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.temporaryFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.temporary.certificate_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangeTemporaryFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.temporaryFile = null
                this.temporary.certificate_file_key = ''
                this.temporary.certificate_file_name = ''
              }
            }
          }
        })
      }
    },

    fnInitDocsFile(key, index) {
      this.documents[key].file = null
      this.documents[key].document_file_key = ''
      this.documents[key].document_file_name = ''
      this.amendment.documents[index].document_file_key = ''
      this.amendment.documents[index].document_file_name = ''
    },

    fnChangeDocsFile(key, index){
      if(!utils.isNull(this.documents[key].file)){
        // 업로드 후 저장객체에 파일키 세팅
        let uploadFile = this.documents[key].file
        let specTypeCode = this.amendment.documents[index].spec_type_code
        let langTypeCode = this.amendment.documents[index].lang_type_code

        let formData = new FormData()
        formData.append("file_data", uploadFile)
        formData.append("spec_type_code", specTypeCode)
        formData.append("lang_type_code", langTypeCode)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.documents[key].document_file_key = res.data.file_key
              this.amendment.documents[index].document_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangeDocsFile(key, index)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.documents[key].file = null
                this.documents[key].document_file_key = ''
                this.documents[key].document_file_name = ''
                this.amendment.documents[index].document_file_key = ''
                this.amendment.documents[index].document_file_name = ''
              }
            }
          }
        })
      }
    },
    fnGoNextStep(){
      this.amendment.ind_amd_abstract       = this.amendment.ind_amd_abstract       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_applcant       = this.amendment.ind_amd_applcant       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_claim_ar       = this.amendment.ind_amd_claim_ar       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_claim_en       = this.amendment.ind_amd_claim_en       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_correspondence = this.amendment.ind_amd_correspondence == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_description_ar = this.amendment.ind_amd_description_ar == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_description_en = this.amendment.ind_amd_description_en == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_drawing_ar     = this.amendment.ind_amd_drawing_ar     == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_drawing_en     = this.amendment.ind_amd_drawing_en     == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_etc            = this.amendment.ind_amd_etc            == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_exhibition     = this.amendment.ind_amd_exhibition     == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_inventor       = this.amendment.ind_amd_inventor       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_priority       = this.amendment.ind_amd_priority       == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_representative = this.amendment.ind_amd_representative == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amd_title          = this.amendment.ind_amd_title          == 'Y' ? 'Y' : 'N'
      this.amendment.ind_amended_confirm    = this.amendment.ind_amended_confirm    == 'Y' ? 'Y' : 'N'

      this.amendment.amend_title_ar         = utils.isNull(this.amendment.amend_title_ar) ? '' : this.amendment.amend_title_ar
      this.amendment.amend_title_en         = utils.isNull(this.amendment.amend_title_en) ? '' : this.amendment.amend_title_en
      this.amendment.amend_abstract_ar      = utils.isNull(this.amendment.amend_abstract_ar) ? '' : this.amendment.amend_abstract_ar
      this.amendment.amend_abstract_en      = utils.isNull(this.amendment.amend_abstract_en) ? '' : this.amendment.amend_abstract_en

      this.$refs.reason.validate().then((valid) => {
        if (valid) {
          this.$refs.titleForm.validate().then((valid1) => {
            if(valid1){
              this.$refs.abstractForm.validate().then((valid2) => {
                if(valid2){
                  this.$refs.filesForm.validate().then((valid3) => {
                    if(valid3){
                      if (this.amendment.ind_amd_claim_ar === 'N') {
                        this.documents.claimAr.document_file_key = ''
                        this.documents.claimAr.document_file_name = ''

                        this.amendment.documents[this.documents.claimAr.index].document_file_key = ''
                        this.amendment.documents[this.documents.claimAr.index].document_file_name = ''
                      }

                      if (this.amendment.ind_amd_claim_en === 'N') {
                        this.documents.claimEn.document_file_key = ''
                        this.documents.claimEn.document_file_name = ''

                        this.amendment.documents[this.documents.claimEn.index].document_file_key = ''
                        this.amendment.documents[this.documents.claimEn.index].document_file_name = ''
                      }

                      if (this.amendment.ind_amd_drawing_ar === 'N') {
                        this.documents.drawAr.document_file_key = ''
                        this.documents.drawAr.document_file_name = ''

                        this.amendment.documents[this.documents.drawAr.index].document_file_key = ''
                        this.amendment.documents[this.documents.drawAr.index].document_file_name = ''
                      }

                      if (this.amendment.ind_amd_drawing_en === 'N') {
                        this.documents.drawEn.document_file_key = ''
                        this.documents.drawEn.document_file_name = ''

                        this.amendment.documents[this.documents.drawEn.index].document_file_key = ''
                        this.amendment.documents[this.documents.drawEn.index].document_file_name = ''
                      }

                      if (this.amendment.ind_amd_description_ar === 'N') {
                        this.documents.descAr.document_file_key = ''
                        this.documents.descAr.document_file_name = ''

                        this.amendment.documents[this.documents.descAr.index].document_file_key = ''
                        this.amendment.documents[this.documents.descAr.index].document_file_name = ''
                      }

                      if (this.amendment.ind_amd_description_en === 'N') {
                        this.documents.descEn.document_file_key = ''
                        this.documents.descEn.document_file_name = ''

                        this.amendment.documents[this.documents.descEn.index].document_file_key = ''
                        this.amendment.documents[this.documents.descEn.index].document_file_name = ''
                      }

                      let attachDocList = this.attachDocList
                      for(let i = 0; i < attachDocList.length; i ++){
                        for(let k = 0; k < attachDocList[i].document_files.length; k ++){
                          let paramItem = {
                            user_document_config_seq : attachDocList[i].user_document_config_seq,
                            name_ar: attachDocList[i].name_ar,
                            name_en: attachDocList[i].name_en,
                            spec_type_code: attachDocList[i].spec_type_code,
                            lang_type_code: attachDocList[i].lang_type_code,
                            user_document_seq : attachDocList[i].document_seq,
                            user_document_file_seq : attachDocList[i].document_files[k].document_file_seq,
                            document_file_key : attachDocList[i].document_files[k].document_file_key,
                            document_file_name: attachDocList[i].document_files[k].document_file_name,
                            ind_multi_upload: attachDocList[i].ind_multi_upload
                          }
                          this.amendment.documents.push(paramItem)
                        }
                      }

                      requestApi({
                        url: '/receivings/amendment/' + this.receipt_no,
                        method: 'PUT',
                        data: this.amendment,
                        callback: (res) => {
                          if (res.res_code === '200') {
                            let snackBarOptions = {
                              text: this.$t('common.message.add.success')
                            }
                            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                            // 이화면 처리 완료 될시에 화면 이동 처리!!
                            this.$router.push({path:'/modification/voluntaryamendment/step3/' + this.receipt_no})
                          }else{
                            if (res.res_code === '401012') {
                              utils.setTokenRefresh().then(() => {
                                this.fnGoNextStep()
                              })
                            } else if (res.res_code === '408') {
                              // timeout이 발생하는 경우 발생하는 팝업의 안내문구 변경
                              let options = {
                                receipt_no: this.receipt_no,
                                search_type_code: '6407'
                              }
                              eventBus.$emit('SHOW_DIALOG_TIMEOUT', options)
                            } else {
                              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                            }
                          }
                        }
                      })
                    } else {
                      //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
                      document.getElementsByClassName('error--text')[0].scrollIntoView(false)
                    }
                  })
                }else{
                  this.$refs.filesForm.validate().then((valid4) => {
                    if(!valid4){
                      //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
                      document.getElementsByClassName('error--text')[0].scrollIntoView(false)
                    }
                  })
                }
              })
            }else{
              this.$refs.abstractForm.validate()
              this.$refs.filesForm.validate()

              document.getElementsByClassName('error--text')[0].scrollIntoView(false)
            }
          })
        } else {
          this.$refs.titleForm.validate()
          this.$refs.abstractForm.validate()
          this.$refs.filesForm.validate()
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },

    fnChangeEditMode(text){
      this.edit[text] = true
    },

    fnShowGetApplicant(flag){
      this.getApplicantBtnShow = flag
    },
    getApplicantForRepresentative(){
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            //this.applicants_representative = res.data.list
            this.applicants_representative = []

            let all_applicants = res.data.list

            requestApi({
              url: '/receivings/amendment/'+this.receipt_no+'/representatives',
              method: 'GET',
              callback: (res) => {
                if (res.res_code === '200') {
                  let used_applicants = []
                  let flag_all = false

                  for(let i=0; i<res.data.list.length; i++){
                    if(res.data.list[i].rep_scope_type_code == '5101'){
                      flag_all = true
                    }else{
                      for(let k=0; k<res.data.list[i].applicants.length; k++){
                        used_applicants.push(res.data.list[i].applicants[k])
                      }
                    }
                  }

                  if(flag_all){
                    this.applicants_representative = []
                  }else{


                    for(let i=0; i<all_applicants.length; i++){
                      let flag_used = false

                      for(let k=0; k<used_applicants.length; k++){
                        if(all_applicants[i].seq == used_applicants[k].seq ){
                          flag_used = true
                        }
                      }

                      if(!flag_used){
                        this.applicants_representative.push(all_applicants[i])
                      }
                    }
                  }

                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.getApplicantForRepresentative()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicantForRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      this.dialog_get_applicants_representative = true
    },

    fnShowRepresentativeForm(seq){
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/applicants/'+seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.addParams.nationality_code = res.data.nationality_code
            this.addParams.residence_country_code = res.data.residence_country_code
            this.addParams.name_ar = res.data.name_ar
            this.addParams.name_en = res.data.name_en
            this.addParams.address_ar = res.data.address_ar
            this.addParams.address_en = res.data.address_en
            this.addParams.pobox_ar = res.data.pobox_ar
            this.addParams.pobox_en = res.data.pobox_en
            this.addParams.birthday_date = res.data.birthday_date
            this.addParams.gender_type_code = res.data.gender_type_code
            this.addParams.telephone = res.data.telephone
            this.addParams.mobile = res.data.mobile
            this.addParams.fax = res.data.fax
            this.addParams.email = res.data.email
            this.addParams.agent_no = res.data.agent_no
            this.addParams.rep_scope_type_code = '5101'

            this.dialog_get_applicants_representative = false
            this.dialog_representative_form = true
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowRepresentativeForm(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSuccessAddRepresentative(){
      this.dialog_representative_form = false
      this.$refs.component_representative.fnSuccess()
    },

    fnIsNotNull(value){
      return !utils.isNull(value)
    },
    getExtIcon(fileName){
      let fileNameArray = fileName.split(".")
      let ext = fileNameArray[fileNameArray.length - 1].toLowerCase()

      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      }else{
        return 'mdi-paperclip'
      }
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    formatDate2 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    formatDate3 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    fnGetAttachDocList(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let attachDocList = res.data.list

            this.requestFormShow = attachDocList.filter( item => item.ind_filing == 'Y' ).length > 0
            this.othersFormShow  = attachDocList.filter( item => item.ind_filing == 'N' ).length > 0

            attachDocList.forEach( item => {
              if(item.document_files.length == 0){
                //넘겨받은 데이터에서 파일 목록이 없을 경우 초기 셋팅을 해야 한다
                let defaultForm = {
                  document_file_seq : '',
                  document_file_key : '',
                  document_file_name : '',
                  file : null
                }
                item.document_files.push(defaultForm)
              } else {
                //넘겨받은 데이터에서 파일 목록이 있을 경우 파일폼만 추가
                item.document_files.forEach( doc_item => {
                  doc_item.file = null
                })
              }
            })

            this.attachDocList = attachDocList
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAttachDocList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAcceptExts(doc_exts){
      let accept = ""

      doc_exts.forEach(item => {
        if(accept.length > 0){
          accept = accept + ","
        }
        accept = accept + "."+item.name_en
      })

      return accept
    },

    fnUploadFile(item, documentFile) {
      let fileExts = item.doc_exts
      let uploadFile = documentFile.file
      let specTypeCode = item.spec_type_code
      let langTypeCode = item.lang_type_code

      if(uploadFile != null){
        if (utils.getFileExtLen(uploadFile, fileExts, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            documentFile.file = null
            documentFile.document_file_key = ''
            documentFile.document_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", uploadFile)
        formData.append("spec_type_code", specTypeCode)
        formData.append("lang_type_code", langTypeCode)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            if (res.res_code === '200') {
              documentFile.document_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadFile(item, documentFile)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                documentFile.file = null
                documentFile.document_file_key = ''
                documentFile.document_file_name = ''
              }
            }
          }
        })
      }
    },

    fnAddFileForm(item){
      let defaultForm = {
        document_file_seq : '',
        document_file_key : '',
        document_file_name : '',
        file : null
      }
      item.document_files.push(defaultForm)
    },

    fnDelFileForm(documentFile, index){
      documentFile.splice(index, 1)
    },

    fnInitFileForm(documentFile) {
      documentFile.document_file_key = ''
      documentFile.document_file_name = ''
      documentFile.file = null
      documentFile.pdf_file_name = ''
      documentFile.pdf_file_path = ''
    },


  }
}
</script>